export default "__VITE_ASSET__783c5ab0__"